import './link_editor_generics.less';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'zoomforth_component_lib/basic_link.jsx';
import Button from 'zoomforth_codesbane_editor/component_lib/button.jsx';
import Divider from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/divider.jsx';
import { TrashIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import SidebarEditorWrapper
  from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/sidebar_editor_wrapper.jsx';

import TranslationsEditingDisabledDiv
  from 'zoomforth_codesbane_editor/component_lib/translations_editing_disabled_div_container.jsx';


const LinkEditorGenerics = ({
  section,
  isValid,
  children,
  saveText,
  sidebarTitle,
  canDeleteLink,
  deleteText,
  onSaveClick,
  onDeleteClick,
  onCancelClick
})=> (
  <SidebarEditorWrapper isInsideTab={section && section._isInsideTab}>
    <div className={classNames('link-editor', { 'inside-tab': section && section._isInsideTab })}>
      <h3 className="link-editor-title">
        {sidebarTitle}
      </h3>

      {children}

      <Button 
        fullwidth 
        disabled={!isValid} 
        onClick={onSaveClick}>
        { saveText }
      </Button>

      <Link className="cancel-link" onClick={onCancelClick}>
        Cancel
      </Link>

      {
        canDeleteLink &&
        <TranslationsEditingDisabledDiv>
          <div className="deleter-container" key="deleter">
            <Divider />
            <Link dark onClick={onDeleteClick}>
               <TrashIcon /> { deleteText }
            </Link>
          </div>
        </TranslationsEditingDisabledDiv>
      }

    </div>
  </SidebarEditorWrapper>
);

LinkEditorGenerics.defaultProps = {
  saveText: 'Save',
  deleteText: 'Delete',
  canDeleteLink: false
};

LinkEditorGenerics.propTypes = {
  isValid: PropTypes.bool.isRequired,
  saveText: PropTypes.string,
  sidebarTitle: PropTypes.string.isRequired,
  canDeleteLink: PropTypes.bool.isRequired,
  deleteText: PropTypes.node.isRequired,
  onDeleteClick: PropTypes.func,
  onSaveClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired
};

export default LinkEditorGenerics;
